@if (data(); as device) {
	<div [class.sh-offline-device]="isOffline()" *transloco="let t; prefix: 'shAgGrid.common.network'">
		@if (isDiscovering()) {
			<div class="sh-discovering-container">
				<prism-tooltip
					[text]="'shAgGrid.common.device-status.device-discovered-loading' | transloco"
					placement="top"
				>
					<prism-progress-indicator type="circular" mode="indeterminate" size="sm"></prism-progress-indicator>
				</prism-tooltip>
				<span>{{ t('discovering') }}</span>
			</div>
		} @else if (isOnline()) {
			<prism-icon icon="check_circle_outline" class="sh-online-icon" data-testid="online-icon"></prism-icon>
			<span> {{ t('online') }}</span>
		} @else if (isOffline()) {
			<prism-icon icon="sh-circle-slash" class="sh-offline-icon" data-testid="offline-icon"></prism-icon>
			<span>{{ t('offline') }}</span>
		} @else if (isError()) {
			<prism-icon icon="error" class="sh-error-icon"></prism-icon>
			<span>{{ t('error') }}</span>
		}
	</div>
} @else {
	<span>--</span>
}
